import { render, staticRenderFns } from "./order_entry_request.vue?vue&type=template&id=210f97d0&scoped=true&"
import script from "./order_entry_request.vue?vue&type=script&lang=js&"
export * from "./order_entry_request.vue?vue&type=script&lang=js&"
import style0 from "./order_entry_request.vue?vue&type=style&index=0&id=210f97d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f97d0",
  null
  
)

export default component.exports